<div *transloco="let t" class="block">
  <h2 class="dynamic-header">{{ t('STAY_INFORMED') }}</h2>
  <p class="dynamic-paragraph">{{ t('NEWSLETTER_DESCRIPTION') }}</p>
  <div class="email-input">
    <mat-form-field subscriptSizing="dynamic" appearance="fill">
      <mat-label>{{ t('YOUR_EMAIL_ADDRESS') }}</mat-label>
      <input [formField]="newsletterEmailForm" matInput type="email" #emailInput />
      <mat-error>{{ t('INVALID_EMAIL_ADDRESS') }}</mat-error>
    </mat-form-field>
    <a
      [attr.aria-label]="t('SEND_ME_NOTIFICATIONS')"
      [queryParams]="{ email: newsletterEmailForm().value() }"
      [disabled]="!newsletterEmailForm().valid()"
      class="small-action-button"
      mat-mini-fab
      routerLink="/notifications">
      <mat-icon svgIcon="arrow_forward" />
    </a>
  </div>
</div>
<div class="newsletter-image">
  <div class="mascot-backdrop">
    <img alt="" height="560" src="/assets/img/mascot-pc.svg" width="584" />
  </div>
</div>
